import { isSessionStorageSupported } from "@zillow/is-local-storage-supported";
const CREDIT_SCORE_LOW_FOR_CONNECT = {
  720: "R_720_739",
  660: "R_660_679",
  620: "R_620_639",
  580: "R_560_599",
  300: "R_300_559"
};
const mapLongTableInput = (answers) => {
  var _a, _b, _c, _d, _e, _f;
  const isPurchase = answers.loanType === "purchase";
  const params = {
    auto: "true",
    loantype: answers.loanType,
    zip: ((_a = answers.location) == null ? void 0 : _a.zipCode) || ((_b = answers.location) == null ? void 0 : _b.name),
    value: answers.propertyValue,
    // TODO: unify Connect and CQ input
    // Check what's inside creditScore key, and if we need to do conversion
    cscore: (_f = (_e = (_d = ((_c = answers == null ? void 0 : answers.creditScore) == null ? void 0 : _c.creditScoreLow) ? CREDIT_SCORE_LOW_FOR_CONNECT[answers.creditScore.creditScoreLow] : answers.creditScore) == null ? void 0 : _d.replace("R_", "")) == null ? void 0 : _e.replace("_", "-")) == null ? void 0 : _f.replace("760-", "760+"),
    va: answers.vaEligible,
    type: answers.propertyType || "SingleFamilyHome",
    use: answers.propertyUsage || "Primary"
  };
  if (isPurchase) {
    params.down = answers.downPayment;
  } else {
    if (answers.cashOut) {
      params.cashOut = answers.helocAmount;
    }
    params.currentbalance = answers.loanBalance;
  }
  return params;
};
const getItem = (storageKey) => {
  if (isSessionStorageSupported()) {
    return sessionStorage.getItem(storageKey);
  }
};
const getMapObject = (storageKey) => {
  try {
    const item = JSON.parse(getItem(storageKey));
    if (item && typeof item === "object" && !Array.isArray(item)) {
      return item;
    }
  } catch {
  }
};
export {
  getItem,
  getMapObject,
  mapLongTableInput
};
